var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"validation"},[_vm._t("default"),_vm._v(" "),_c('to-toggle-section',{attrs:{"expanded":!!_vm.error}},[_c('div',{staticClass:"validation__content flex flex--align pt-1 pb-2"},[_c('to-icon',{staticClass:"mr-1",attrs:{"name":"alert-circle"}}),_vm._v("\n      "+_vm._s(_vm.error)+"\n    ")],1)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }